import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class ClassAttribute extends AbstractBlock {
  constructor() {
    super('class_att', t.to('クラス', 'class_attribute'));
  }

  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setAttributeColor(block);

    const className = new Blockly.FieldTextInput('A');
    block
      .appendDummyInput()
      .appendField(t.to('クラス', 'to_class'))
      .appendField(className, 'className')
      .appendField(t.to(`に分類する`, 'classify'));
    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const attribute = CodeSetting.getSubAttributeCode(block);
    const className = CodeSetting.getFieldValue(block, 'className');
    const str = `entity.classList.add( \`${className}\`);${attribute}`;
    return [str];
  }
}
